import { missingInput, divisionByZero } from '../warnings';
import { formulaOk, formulaUnknown, type FormulaResult } from './types';

/**
 * SPEC-008 §30/§81/METRIC-REQ-010 — ROI = (return - totalCost) / totalCost.
 * The result may legitimately be negative (a loss); only the zero-cost
 * denominator is treated as undefined.
 */
export function roi(returnValue: number | null, totalCost: number | null): FormulaResult {
  const explanation = {
    metric: 'roi',
    formula: '(return - totalCost) / totalCost',
    inputs: { return: returnValue, totalCost },
    result: null,
  };
  if (returnValue === null || totalCost === null) {
    return formulaUnknown(explanation, [missingInput('Return and total cost are both required to calculate ROI.')]);
  }
  if (totalCost === 0) {
    return formulaUnknown(explanation, [divisionByZero('ROI is undefined when total cost is zero.')]);
  }
  const value = (returnValue - totalCost) / totalCost;
  return formulaOk(value, { ...explanation, result: value }, []);
}
